import CardTemplate from "components/card/card-template/CardTemplate";
import { DateOfBirthField, LastNameField } from "components/form-fields";
import { useForm } from "react-hook-form";

interface ConfirmYourIdentityFormData {
    lastName: string;
    dateOfBirth: {
        month: string;
        day: string;
        year: string;
    };
}

interface ConfirmYourIdentityCardProps {
    onSubmit: (data: ConfirmYourIdentityFormData) => void | Promise<void>;
    error?: string | null;
}

const ConfirmYourIdentityCard = ({ onSubmit, error }: ConfirmYourIdentityCardProps) => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<ConfirmYourIdentityFormData>();

    const dateOfBirth = watch("dateOfBirth");

    return (
        <CardTemplate className="text-base-content min-h-[308px] tablet:min-h-[308px]" title="Confirm Your Identity">
            <form id="confirm-your-identity-form" data-testid="confirm-your-identity-form" onSubmit={handleSubmit(onSubmit)}>
                <div
                    data-testid="confirm-your-identity-content"
                    className="font-medium text-base-content text-base flex flex-col gap-4 pt-1"
                >
                    <p className="text-sm leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                        Confirm your identity to continue your application.
                    </p>
                    <LastNameField
                        register={register("lastName", {
                            required: "Last name is required",
                        })}
                        error={errors.lastName?.message}
                        disabled={false}
                        id="lastName"
                        width="w-full"
                        placeholder="Last"
                    />
                    <DateOfBirthField
                        monthRegister={register("dateOfBirth.month", {
                            required: "Month is required",
                        })}
                        dayRegister={register("dateOfBirth.day", {
                            required: "Day is required",
                        })}
                        yearRegister={register("dateOfBirth.year", {
                            required: "Year is required",
                        })}
                        monthValue={dateOfBirth?.month || ""}
                        dayValue={dateOfBirth?.day || ""}
                        yearValue={dateOfBirth?.year || ""}
                        monthError={errors.dateOfBirth?.month?.message}
                        dayError={errors.dateOfBirth?.day?.message}
                        yearError={errors.dateOfBirth?.year?.message}
                        disabled={false}
                        id="dateOfBirth"
                    />
                    <button type="submit" className="hidden" />
                    {error && (
                        <p data-testid="authentication-error" className="text-sm text-error font-medium" role="alert">
                            {error}
                        </p>
                    )}
                </div>
            </form>
        </CardTemplate>
    );
};

export default ConfirmYourIdentityCard;
export type { ConfirmYourIdentityFormData };
